<template>
  <vue-resize-sensor @resize="checkOverflow" tag="span">
    <v-tooltip
      v-bind="$attrs"
      :location="$attrs.location || 'right'"
      v-model="showTooltip"
      :disabled="$attrs.disabled || hasNoOverflow"
    >
      <template #activator="{ props }">
        <span @click="!hideIcon && toggleTooltip($event)" v-bind="props">
          <slot name="content">
            <v-icon
              class="tooltip-icon"
              :class="$attrs.class"
              :color="isWarning ? 'warning' : 'primary'"
              data-test="info-tooltip"
              :size="size"
              @click.stop.prevent="toggleTooltip"
              @mousedown.stop
            >
              info--filled
            </v-icon>
          </slot>
        </span>
      </template>
      <div class="d-flex" :class="{ 'text-wrap tooltip-content': isClicked }" ref="tooltipContent">
        <slot />
        <v-icon
          v-if="isClicked"
          icon="close"
          color="grey"
          data-test="close-icon"
          size="x-small"
          class="ml-1 cursor-pointer"
          @click.prevent="closeTooltip"
        />
      </div>
    </v-tooltip>
  </vue-resize-sensor>
</template>

<script>
import eventBus from './eventBus';
import VueResizeSensor from '@seregpie/vue-resize-sensor';

export default {
  name: 's-tooltip',
  inheritAttrs: false,
  components: { VueResizeSensor },
  props: {
    hideIcon: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'small'
    },
    verticalOverflow: {
      type: Boolean,
      default: false
    },
    isWarning: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showTooltip: false,
      isClicked: false,
      tooltipId: Math.random().toString(36).slice(2, 11),
      hasNoOverflow: null
    };
  },
  watch: {
    showTooltip(newVal) {
      if (this.isClicked && !newVal) {
        this.showTooltip = true;
      }
    }
  },
  created() {
    eventBus.on('tooltipOpened', (id) => {
      if (id !== this.tooltipId && this.showTooltip) {
        this.closeTooltip();
      }
    });
  },
  mounted() {
    document.addEventListener('click', this.handleOutsideClick);
  },
  unmounted() {
    eventBus.off('tooltipOpened');
    document.removeEventListener('click', this.handleOutsideClick);
  },
  methods: {
    toggleTooltip(event) {
      event.stopPropagation();
      this.showTooltip = true;
      this.isClicked = true;
      eventBus.emit('tooltipOpened', this.tooltipId);
    },
    closeTooltip() {
      this.showTooltip = false;
      this.isClicked = false;
    },
    handleOutsideClick(event) {
      const tooltipContent = this.$refs.tooltipContent;
      if (!tooltipContent?.contains(event.target)) {
        this.closeTooltip();
      }
    },
    async checkOverflow() {
      this.$nextTick(() => {
        // Check if parent has overflow class and tooltip needed.
        const label = this.$el.querySelector(`.s-overflow-tooltip`);
        if (label) {
          this.hasNoOverflow = this.verticalOverflow
            ? label.scrollHeight <= label.clientHeight
            : label.scrollWidth <= label.offsetWidth;
        }
      });
    }
  }
};
</script>
